import React, {useEffect, useState} from 'react'
import {CardBody, Col, FormGroup, Modal, Row} from "reactstrap";
import IcoMoon from "react-icomoon";
import {ButtonContainer} from "@pages/reusable-components/styled-components";
import TableCustom from 'views/pages/components/TableCustom'
import InputCustom from 'views/pages/components/InputCustom'
import {InputArraySelect, InputKeySelect,} from 'views/pages/components/InputSelect'
import axios from "axios";
import { API_URL, formatDate, formatDateShortGB, taskStatuses } from '@constants/index';
import IconSet from "@assets/selection.json";
import notify from "@utils/notify";
interface VehicleTasks {
    initialVehicle: any,
}

const VehicleTasksComponent: React.FC<VehicleTasks> = ({initialVehicle}) => {

    const [task, setTask] = useState('')
    const [vehicle, setVehicle] = useState(null)
    const [vehicleTasks, setVehicleTasks] = useState('')
    const [dealerMembers, setDealerMembers] = useState([])
    const [vehicleTaskStatuses, setVehicleTaskStatuses] = useState('')
    const [taskErrors, setTaskErrors] = useState('')
    const [deleteModal, setDeleteModal] = useState({
        show: false,
        header: '',
        body: '',
        onClick: null,
    })
    const getVehicleTasks = async (id) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${API_URL}/vehicle/${id}/task`,

            })

            const data = response.data;
            setVehicleTasks(data.data.tasks);
            let dealerMembers = data.data.dealerMembers || []
            dealerMembers.forEach(dealer => {
                dealer.text = dealer.name
            })
            setDealerMembers(dealerMembers)
            setVehicleTaskStatuses(data.data.statuses)
        } catch (err) {
            console.err(err);
        }
    }

    useEffect(() => {
       if (initialVehicle && Object.keys(initialVehicle).length) {
           setVehicle(initialVehicle)
           getVehicleTasks(initialVehicle.id);
       }
    }, [initialVehicle]);

    const [addTaskModal, setAddTaskModal] = useState({
        show: false,
        header: '',
        division: '',
    })
    const deleteTask = (taskId) => {
        axios({
            method: 'DELETE',
            url: `${API_URL}/vehicle/${vehicle.id}/task/${taskId}`,

        })
            .then(response => {
                setDeleteModal({
                    ...deleteModal,
                    show: false,
                });
                if (response.status === 204) {
                    const data = response.data;
                    notify.success(data.message);
                    getVehicleTasks(vehicle.id);
                }
            })
            .catch(error => {
                setDeleteModal({
                    ...deleteModal,
                    show: false,
                });
                console.error('error :: ', error.response);
                notify.warning(error.response && error.response.statusText ? error.response.statusText : 'Error occur.');
            })
    }
    const addTask = () => {
        axios({
            method: 'POST',
            url: `${API_URL}/vehicle/${vehicle.id}/task`,

            data: {
                ...task,
                task_category: 'vehicle-manually',
                task_assignee: task.taskAssignee,
            },
        })
            .then(response => {
                setAddTaskModal({
                    ...addTaskModal,
                    show: false
                })
                if (response.status === 200) {
                    const data = response.data;
                    setVehicle({
                        ...vehicle,
                        tasks: data.data.tasks,
                    })
                    setTask('');
                    // dispatch(actions.getNotifications(token));
                    notify.success(data.message);
                    getVehicleTasks(vehicle.id);
                }
            })
            .catch(error => {
                setTaskErrors('');
                console.error('error :: ', error.response);
                if (error.response && error.response.status === 422) {
                    setTaskErrors(error.response.data.errors)
                    return
                }
                setAddTaskModal({
                    ...addTaskModal,
                    show: false
                });
                notify.warning(error.response && error.response.statusText ? error.response.statusText : 'Error occur.');
            })
    }
    const updateTask = () => {
        axios({
            method: 'PUT',
            url: `${API_URL}/vehicle/${vehicle.id}/task/${task.uuid}`,
            data: {
                ...task,
                task_assignee: task.taskAssignee,
            },
        })
            .then(response => {
                setAddTaskModal({
                    ...addTaskModal,
                    show: false
                })
                if (response.status === 200) {
                    const data = response.data;
                    console.log('response data :: ', data);
                    setVehicle({
                        ...vehicle,
                        tasks: data.data.tasks,
                    })
                    setTask('');
                    // dispatch(actions.getNotifications(token));
                    notify.success(data.message);
                    getVehicleTasks(vehicle.id);
                }
            })
            .catch(error => {
                setTaskErrors('');
                console.error('error :: ', error.response);
                if (error.response && error.response.status === 422) {
                    setTaskErrors(error.response.data.errors)
                    return
                }
                setAddTaskModal({
                    ...addTaskModal,
                    show: false
                });
                notify.warning(error.response && error.response.statusText ? error.response.statusText : 'Error occur.');
            })
    }
    return (
        <CardBody>
        <Modal
            isOpen={addTaskModal.show}
            toggle={() => setAddTaskModal({
                ...addTaskModal,
                show: false
            })}
            className="modal-dialog-centered"
        >
            <div className="modal-header">
                <h6 className="modal-title">{addTaskModal.header}</h6>
                <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => setAddTaskModal({
                        ...addTaskModal,
                        show: false
                    })}
                >
                    <span aria-hidden={true}>×</span>
                </button>
            </div>
            <div className="modal-body">
                <InputCustom
                    newLabel={`Task title`}
                    required
                    checkValid={false}
                    value={task && task.title ? task.title : ''}
                    onChange={(e) => setTask({
                        ...task,
                        title: e.target.value,
                    })}
                    invalid={taskErrors && taskErrors.title ? true : false}
                    errorMessage={taskErrors && taskErrors.title ? taskErrors.title : ''}
                />
                <InputCustom
                    type={`textarea`}
                    newLabel={`Description`}
                    rows={5}
                    value={task && task.comments ? task.comments : ''}
                    onChange={(e) => setTask({
                        ...task,
                        comments: e.target.value,
                    })}
                />
                <FormGroup className={'d-flex align-items-center'}>
                    <label className="form-control-label w-50">Assign to</label>
                    <div className={'w-100'}>
                        <InputArraySelect
                            options={dealerMembers}
                            multiple={true}
                            value={task?.taskAssignee || []}
                            onChange={(e) => {
                                setTask({
                                    ...task,
                                    taskAssignee: e.target.value,
                                })
                            }}
                            valueKey="id"
                            labelKey="name"
                        />
                    </div>

                    {taskErrors && taskErrors.task_assignee && <div className="invalid-feedback" style={{ display: 'block' }}>
                        {taskErrors.task_assignee}
                    </div>}
                </FormGroup>
                <InputKeySelect
                    newLabel={`Task status`}
                    required
                    value={task && task.status ? task.status : ''}
                    options={taskStatuses}
                    onChange={(e) => setTask({
                        ...task,
                        status: e.target.value,
                    })}
                    defaultOption={true}
                    invalid={taskErrors && taskErrors.status ? true : false}
                    errorMessage={taskErrors && taskErrors.status ? taskErrors.status : ''}
                />
                <InputCustom
                    type={`date`}
                    newLabel={`Due date`}
                    value={task && task.due_date ? formatDate(task.due_date) : ''}
                    onChange={(e) => setTask({
                        ...task,
                        due_date: e.target.value,
                    })}
                    invalid={taskErrors && taskErrors.due_date ? true : false}
                    errorMessage={taskErrors && taskErrors.due_date ? taskErrors.due_date : ''}
                />
            </div>
            <div className="modal-footer justify-content-end">
                <ButtonContainer
                    reverse
                    disabled={!task.title || !task.status}
                    onClick={() => addTaskModal.division === 'create' ? addTask() : updateTask()}
                >
                    {`Save`}
                </ButtonContainer>
            </div>
        </Modal>
            <Modal
                isOpen={deleteModal.show}
                toggle={() => setDeleteModal({
                    ...deleteModal,
                    show: false
                })}
                className="modal-dialog-centered"
            >
                <div className="modal-header main-color">
                    <h6 className="modal-title">{deleteModal.header}</h6>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => setDeleteModal({
                            ...deleteModal,
                            show: false
                        })}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>
                <div className="modal-body ">
                    <span>{deleteModal.body}</span>
                </div>
                <div className="modal-footer justify-content-end">
                    <ButtonContainer
                        reverse
                        onClick={deleteModal.onClick}
                    >
                        {`Delete`}
                    </ButtonContainer>
                </div>
            </Modal>
        <Row>
            <Col md={12}>
                <div className="d-flex justify-content-between">
                    <div>
                        <h2 className="title mb-0">Tasks</h2>
                    </div>
                    {/* {hasPermission(profilePermissions, 'create-deals-tasks') && allowEdit && */}
                    <ButtonContainer reverse
                                     onClick={() => {
                                         setTask('')
                                         setAddTaskModal({
                                             ...addTaskModal,
                                             show: true,
                                             header: 'Add Task',
                                             division: 'create'
                                         })
                                     }}
                    >Add task</ButtonContainer>
                    {/* } */}
                </div>
            </Col>
        </Row>
        <TableCustom
            loading={false}
            delay={true}
            items={vehicleTasks}
            keyField={`title`}
            searchField={true}
            columns={[
                {
                    dataField: "title",
                    text: "Task",
                    sort: true
                },
                {
                    dataField: "due_date",
                    text: "Due at",
                    sort: true,
                    formatter: (rowContent, row) => {
                        return row.due_date ? formatDateShortGB(row.due_date) : ''
                    }
                },
                {
                    dataField: "created_by",
                    text: "Created by",
                    sort: true,
                    formatter: (rowContent, row) => {
                        return row.owner.name
                    }
                },
                {
                    dataField: "status",
                    text: "Status",
                    sort: true,
                    formatter: (rowContent, row) => {
                        return vehicleTaskStatuses[row.status]
                    }
                },
                {
                    dataField: "",
                    text: "Action",
                    formatter: (rowContent, row) => {
                        return (
                            <>
                                {/* {hasPermission(profilePermissions, 'update-deals-tasks') && hasPermission(profilePermissions, 'delete-deals-tasks') && */}
                                {/* {update(profilePermissions, authUserTeam, deal) && */}
                                <IcoMoon
                                    className={'cursor-pointer'}
                                    iconSet={IconSet}
                                    icon={'edit'}
                                    size={24}
                                    onClick={() => {
                                        setTask({
                                            ...row,
                                            due_date: formatDate(row.due_date)
                                        })
                                        setTaskErrors('')
                                        setAddTaskModal({
                                            ...addTaskModal,
                                            show: true,
                                            header: 'Edit task',
                                            division: 'update'
                                        })
                                    }}
                                />
                                {/* } */}
                                <IcoMoon
                                    className={'cursor-pointer'}
                                    iconSet={IconSet}
                                    icon={'delete_outline'}
                                    size={24}
                                    onClick={() => {
                                        setDeleteModal({
                                            ...deleteModal,
                                            show: true,
                                            header: 'Delete task',
                                            body: 'Are you sure to delete this task?',
                                            onClick: () => deleteTask(row.uuid)
                                        })
                                    }}
                                />

                                {/* } */}
                            </>
                        )
                    }
                }
            ]}
        />
    </CardBody>)
}
export default VehicleTasksComponent